import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';
import { theme } from '@/theme/getTheme';

import type { CheckboxProps } from './Checkbox';

export const Wrapper = styled(Typography)<
  Pick<CheckboxProps, 'size' | 'disabled' | 'isFluid'>
>`
  gap: ${(props) => props.theme.space.s075};
  align-items: flex-start;
  cursor: pointer;

  ${({ isFluid }) =>
    isFluid
      ? css`
          display: flex;
          width: 100%;
        `
      : css`
          display: inline-flex;
          justify-content: center;
        `}
`;

export const Input = styled.input<{
  disabled: boolean;
  hasError?: boolean;
}>`
  ${({
    checked,
    disabled,
    hasError,
    theme: {
      components: { checkbox },
    },
  }) => css`
    color: ${hasError ? theme.colors.darkError : theme.colors.white};
    box-shadow: inset 0 0 0 ${checkbox.borderWidth}px
      ${hasError ? theme.colors.darkError : theme.colors.quinaryGrey};
    width: ${checkbox.size.width}px;
    height: ${checkbox.size.height}px;
    opacity: ${checked && disabled ? 0.3 : 1};
  `}

  appearance: none;
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0;
  display: grid;
  place-content: center;
  position: relative;

  cursor: pointer;

  &:before {
    content: '';
    transform: scale(0);
    transition: 0.2s transform ease-in-out;
    ${({
      theme: {
        colors,
        components: { checkbox },
      },
    }) => css`
      background-color: ${checkbox.icon.color ?? colors.default};
      width: ${checkbox.icon.width}px;
      height: ${checkbox.icon.height}px;
      transform-origin: bottom left;
      clip-path: polygon(21% 48%, 37% 64%, 77% 23%, 82% 28%, 37% 74%, 16% 53%);
    `}
  }

  &:disabled {
    ${({
      theme: {
        components: { checkbox },
      },
    }) => css`
      cursor: not-allowed;
      background-color: ${theme.colors.disableGrey};
      box-shadow: inset 0 0 0 ${checkbox.borderWidth}px
        ${theme.colors.disableGrey};
    `}
  }

  &:checked {
    ${({
      theme: {
        components: { checkbox },
      },
    }) => css`
      background-color: ${checkbox.markColor};

      box-shadow: inset 0 0 0 ${checkbox.borderWidth}px ${checkbox.markColor};

      &:disabled {
        background-color: ${theme.colors.disableGrey};
        box-shadow: inset 0 0 0 ${checkbox.borderWidth}px
          ${theme.colors.disableGrey};

        &:before {
          background-color: ${theme.colors.secondaryGrey};
        }
      }
    `}

    &:before {
      transform: scale(1);
    }
  }
`;
